import React, { useEffect, useState } from "react";

import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";

const Reading = ({ data }) => {
  const [languageData, setLanguageData] = useState(null);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/dashboard/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <>
      <div className="col-xl-4 col-lg-6 col-sm-6 px-cd-2">
        <div className="card custom-card">
          <div className="card-body h-100" >
            <div className="d-flex align-items-start">
              <div className="flex-1">
                <div className="d-flex align-items-start justify-content-between">
                  <span className="mb-0 flex-1 fs-14">
                    {languageData.indicators.readings}
                  </span>
                  <div className="ms-2">
                    <span className="avatar bg-success-transparent text-success">
                      <i className="bx bxs-spa fs-16"></i>
                    </span>
                  </div>
                </div>
                {data.favorite_expert ? (
                  <h3 className="mb-0 fs-18">{data.readings}</h3>
                ) : (
                  <span className="mb-0 fs-15">⚊</span>
                )}
                <div className="flex-between">
                  {/* <span className="text-muted fs-18">53 {languageData.indicators.days} {languageData.indicators.ago}</span> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reading;
